import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useContext, watch } from '@nuxtjs/composition-api';

import { useElementHover } from '@vueuse/core';
import { useMediaAsset } from '~/composables';

interface Props {
  menuItem?: any;
  isActive?: boolean;
  isMenuOpen?: boolean;
  dark?: boolean;
}
interface Emits {
  (e: 'setActiveItem'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMainMenuItem',
  props: {
    menuItem: { default: () => [] },
    isActive: { type: Boolean, default: false },
    isMenuOpen: { type: Boolean, default: false },
    dark: { type: Boolean, default: false }
  },
  emits: ["setActiveItem"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'setActiveItem'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { menuItem: any, isActive: boolean, isMenuOpen: boolean, dark: boolean };




const {
  $config: { joinuApp: isJoinuApp },
} = useContext();
const menuLink = ref();
const isHoveredLink = useElementHover(menuLink);
const { getAssetUrl } = useMediaAsset();
const activeCategoryId = ref(null);
const activeCategoryName = ref(null);
const activeCategoryImage = ref<string>();
const activeCategoryChildren = ref<null | any[]>(null);

const hasChildren = computed(() => Boolean(props.menuItem.children?.length));

const hasImages = computed(
  () =>
    hasChildren.value &&
    props.menuItem.children.some((item: any) => item.image),
);

const setActiveCategory = (category: any) => {
  activeCategoryId.value = category?.id ?? null;

  activeCategoryName.value = category?.name ?? null;
  activeCategoryImage.value = category?.image?.path
    ? `url('${getAssetUrl(category.image.path)}')`
    : '';
  activeCategoryChildren.value =
    category?.children && category?.children.length ? category?.children : null;
};
const menuItemTextClass = computed(() =>
  props.dark || props.isMenuOpen || isJoinuApp ? 'text-slate' : 'text-white',
);

watch(isHoveredLink, (value) => {
  emit('setActiveItem');
  if (!value) setActiveCategory(null);
});

return { __sfc: true,props, emit, isJoinuApp, menuLink, isHoveredLink, getAssetUrl, activeCategoryId, activeCategoryName, activeCategoryImage, activeCategoryChildren, hasChildren, hasImages, setActiveCategory, menuItemTextClass }
}

})